import React, { useReducer, useEffect } from "react";
import Reducer from "./reducer";
import Context from "./context";
import { initialState } from "./initialState";
import { loadData } from "./service";
import Html from "./html";
import DateFilter from "./components/dateFilter";

const FtmRevenue = () => {
    const [state, dispatch] = useReducer(Reducer,initialState);

    useEffect(() => {
        loadData(state.page_number, state.sort_key, state.sort_direction, state.start_date, state.end_date, state.serach_text, dispatch);
    }, [state.page_number, state.sort_key, state.sort_direction, state.end_date, state.serach_text]);

    return(
        <Context.Provider value={{state, dispatch}}>
            <Html/>
            <DateFilter/>
        </Context.Provider>
    );
}

export default FtmRevenue;